import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useContext } from 'react';
import Spinner from '../spinner';
import Typography from '../typography';
import { CardContextObject } from './context/CardContext';
import { getChildCardElementType } from './helpers/getChildCardElementType';
import { CardContentContainer } from './styles/card-content.styled';
const CardContent = ({ children, reference, index }) => {
    const { mode, useBackground, dataTest, useRedesign } = useContext(CardContextObject);
    const useTypography = typeof children === 'string';
    const childrenArray = Children.toArray(children);
    const cardContent = [...childrenArray].filter((child) => getChildCardElementType(child) !== 'CARD_FOOTER');
    const cardContentFooter = [...childrenArray].filter((child) => getChildCardElementType(child) === 'CARD_FOOTER');
    return mode === 'loading' ? (_jsx(Spinner, { message: "Een ogenblik geduld, alstublieft" })) : (_jsxs(_Fragment, { children: [_jsx(CardContentContainer, Object.assign({ as: useTypography ? Typography : 'div', className: "PONCHO-card__content", id: `${reference}-content`, "$useBackground": useBackground, "$useRedesign": useRedesign, "$footer": cardContentFooter.length > 0, "data-test": `${dataTest}-content${index !== undefined ? `-${index}` : ''}` }, (useTypography
                ? {
                    variant: 'body-text',
                    tagName: 'div',
                }
                : {}), { children: cardContent })), cardContentFooter] }));
};
CardContent.CARD_ELEMENT = 'CARD_CONTENT';
export default CardContent;
